import { useTranslation } from 'react-i18next';
import { DataTablePlaceholder } from './data-table-placeholder';

export const DefaultErrorPlaceholder = () => {
  const { t } = useTranslation();
  return <DataTablePlaceholder variant="error" title={t('errorLoadingData')} />;
};
